import { defaultAllSelection } from "services/constants/selections";
import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import { Loader } from "components/Loader";
import sessionHandling from "services/utils/notificationUtils";
import BSDateRangePicker from "pages/MyZone/Status/DateRangePicker";
import { CustomAutoCompleteWithLogo } from "components/CustomComponents/CustomAutoCompleteWithLogo";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { TableEmptyState } from "components/CustomComponents/EmptyState";
import {
  themes,
  tableContainerSx,
  tableRowSx,
  scrollTop,
  optionalAvathar,
} from "services/constants";
import {
  NavigateNext,
  KeyboardArrowDown,
  DownloadForOffline,
} from "@mui/icons-material";

export const keys = [
  "user_name",
  "project.projectname",
  "task_code",
  "taskname",
  "task_owner.username",
  "stask_status",
  "date",
  "start_time",
  "end_time",
  "hours",
];

const ProjectTaskReport = ({ updateShowReport }) => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const { domain, token, userDetails, globalSearchValue } = useSelector(
    (state) => state.tokenReducer
  );
  const [isLoading, setIsLoading] = useState(false);
  const [selectedAssignee, setSelectedAssignee] = useState("All");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [expandUserDet, setExpandUserDet] = useState(0);
  const [selectedAssigneeId, setSelectedAssigneeId] = useState("");
  const [selectedProject, setSelectedProject] = useState("All");
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [allProjectDetails, setAllProjectDetails] = useState([]);
  const [allUserDetails, setAllUserDetails] = useState([]);
  const [allProRepDetails, setAllProRepDetails] = useState([]);
  const [allUser, setAllUser] = useState(allProRepDetails);
  const containerRef = useRef(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [expandTaskDetails, setExpandTaskDetails] = useState([]);
  const [expandIsLoading, setExpandIsLoading] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [totWorkingHours, setTotWorkingHours] = useState("");
  const [getDetailedReportData, setGetDetailedReportData] = useState(false);
  const [updatedDetailReportData, setUpdatedDetailsReportData] = useState([]);
  const [selectedUser, setSelectedUser] = useState("All");
  const [showAutoCompleteAvathar, setShowAutoCompleteAvathar] = useState(false);

  useEffect(() => {
    const fetchProjectDetails = async () => {
      try {
        const response = await fetch(
          `${domain}get-project-based-user/?user_id=${userDetails?.id}&company_id=${requestCompanyId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          const AllProjectsData = res.map((obj) => ({
            ...obj,
            label: obj.project_name,
          }));
          setAllProjectDetails(AllProjectsData);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error('REQUEST_FAILED');
        }
      } catch (error) {
        console.error('[Projecttaskreport] operation failed:', error);
        showToast("error", "Couldn't load the project report. Please try again.");
      }
    };
    fetchProjectDetails();
  }, [domain, token, userDetails?.id, requestCompanyId]);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const selProjectId =
          selectedProject === "All" ? defaultAllSelection : selectedProjectId;

        const response = await fetch(
          `${domain}project-based-members/?project_id=${selProjectId}&company_id=${requestCompanyId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          const AllUserData = res.map((obj) => ({
            ...obj,
            label: obj.user_name,
          }));
          setAllUserDetails(AllUserData);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error('REQUEST_FAILED');
        }
      } catch (error) {
        console.error('[Projecttaskreport] operation failed:', error);
        showToast("error", "Couldn't load the project report. Please try again.");
      }
    };
    fetchUserDetails();
  }, [domain, token, selectedProject, selectedProjectId, requestCompanyId]);

  useEffect(() => {
    const fetchUsertaskDetails = async () => {
      setIsLoading(true);
      try {
        const selProId = selectedProject === "All" ? defaultAllSelection : selectedProjectId;
        const selUsrId =
          selectedAssignee === "All" ? defaultAllSelection : selectedAssigneeId;
        let searchStartDate = startDate.split("/").reverse().join("-");
        let searchEndDate = endDate.split("/").reverse().join("-");
        const response = await fetch(
          `${domain}task-hours?project_id=${selProId}&user_id=${selUsrId}&start_date=${searchStartDate}&end_date=${searchEndDate}&company_id=${requestCompanyId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          setAllProRepDetails(res?.tasks);
          setAllUser(res?.tasks);
          setTotWorkingHours(res?.total_working_hours);
          setExpandUserDet(0);
          setGetDetailedReportData(true);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error('REQUEST_FAILED');
        }
      } catch (error) {
        console.error('[Projecttaskreport] operation failed:', error);
        showToast("error", "Couldn't load task report data. Please try again.");
      } finally {
        setIsLoading(false);
      }
    };
    if (startDate && endDate) {
      fetchUsertaskDetails();
    }
  }, [
    selectedAssignee,
    selectedProject,
    domain,
    token,
    selectedAssigneeId,
    selectedProjectId,
    startDate,
    endDate, requestCompanyId
  ]);

  useEffect(() => {
    const getDetailProjectReport = () => {
      let Urls = [],
        overallDetProRepData = [];
      let searchStartDate = startDate.split("/").reverse().join("-");
      let searchEndDate = endDate.split("/").reverse().join("-");
      const selUsrId = selectedAssignee === "All" ? defaultAllSelection : selectedAssigneeId;
      allUser.forEach((element) => {
        let urls = [
          ...Urls,
          {
            taskurl: `${domain}task-detailed-report/?task_id=${element?.id}&user_id=${selUsrId}&start_date=${searchStartDate}&end_date=${searchEndDate}&company_id=${requestCompanyId}`,
            data: element,
          },
        ];
        Urls = urls;
      });
      Promise.all(
        Urls.map((url) =>
          fetch(url?.taskurl, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          })
            .then((r) => r.json())
            .then((data) => ({ data, url }))
        )
      )
        .then(function (responses) {
          return Promise.all(
            responses.map(function (response) {
              if (!response.error) {
                const mergedDataArray = response.data.map((item) => {
                  return { ...item, ...response.url.data };
                });

                overallDetProRepData = [
                  ...overallDetProRepData,
                  ...mergedDataArray,
                ];

                setUpdatedDetailsReportData(overallDetProRepData);
                return overallDetProRepData;
              } else {
                return overallDetProRepData;
              }
            })
          );
        })
        .catch((error) => console.log(error));
    };
    if (getDetailedReportData) {
      getDetailProjectReport();
      setGetDetailedReportData(false);
    }
  }, [
    domain,
    getDetailedReportData,
    token,
    allProRepDetails,
    startDate,
    endDate,
    selectedAssignee,
    selectedAssigneeId,
    allUser, requestCompanyId
  ]);

  const handleStartDate = async (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getSummarizedUserReport = () => {
    let dataPreparation = [];
    allUser?.forEach((element) => {
      let overAllData = {
        taskowner: element?.task_owner?.username,
        employee_id: element?.task_owner?.employee_id,
        projectname: element?.project?.projectname,
        taskname: element?.taskname,
        date: element?.time_entries[0]?.date,
        status: element?.work_flow_status?.name
          ? element?.work_flow_status?.name
          : "N/A",
        hours: element?.total_time,
      };
      dataPreparation = [...dataPreparation, overAllData];
    });
    const SummarizedReport = ["Summarized Project Report"];
    const Space = [""];
    const Date = ["Date"];
    const Project = ["Project Name"];
    const User = ["User Name"];
    const ProjectWorkingHour = ["Total Working Hours"];
    SummarizedReport.push("");
    Date.push(`${startDate} to ${endDate}`);
    User.push(selectedAssignee);
    Project.push(selectedProject);
    ProjectWorkingHour.push(totWorkingHours ? totWorkingHours : "00:00");
    Space.push("");
    const items = dataPreparation;
    const TableHead = ["Task Owner"];
    TableHead.push("Employee Id");
    TableHead.push("Project Name");
    TableHead.push("Task Name");
    TableHead.push("Date");
    TableHead.push("Status");
    TableHead.push("Working Hours");

    const replacer = (key, value) => (value === null ? "N/A" : value);
    const header = Object.keys(items[0]);
    let csv = items.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(",")
    );
    csv.unshift(TableHead.join(","));
    csv.unshift(Space.join(","));
    csv.unshift(ProjectWorkingHour.join(","));
    csv.unshift(User.join(","));
    csv.unshift(Project.join(","));
    csv.unshift(Date.join(","));
    csv.unshift(SummarizedReport.join(","));
    csv = csv.join("\r\n");
    const ConvertData = csv;
    const element = document.createElement("a");
    const file = new Blob([ConvertData], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download = "SummarizedProjectReport.csv";
    document.body.appendChild(element);
    element.click();
  };

  const getDetailedProjectReport = () => {
    if (updatedDetailReportData.length !== 0) {
      let dataPreparation = [];
      updatedDetailReportData?.forEach((element) => {
        let overAllData = {
          taskowner: element?.task_owner?.username,
          assignee: element?.detail?.assignee,
          employee_id: element?.detail?.employee_id,
          projectname: element?.project?.projectname,
          taskcode: element?.task_code,
          taskname: element?.taskname,
          starttime: element?.start_time,
          endtime: element?.end_time,
          status: element?.task_status ? element?.task_status : "N/A",
          hours: element?.hours,
        };
        dataPreparation = [...dataPreparation, overAllData];
      });
      const DetailedReport = ["Detailed Project Report"];
      const Space = [""];
      const Date = ["Date"];
      const Project = ["Project Name"];
      const User = ["User Name"];
      const ProjectWorkingHour = ["Total Working Hours"];
      DetailedReport.push("");
      Date.push(`${startDate} to ${endDate}`);
      User.push(selectedAssignee);
      Project.push(selectedProject);
      ProjectWorkingHour.push(totWorkingHours ? totWorkingHours : "00:00");
      Space.push("");
      const items = dataPreparation;
      const TableHead = ["Task Owner"];
      TableHead.push("Assignee");
      TableHead.push("Employee Id");
      TableHead.push("Project Name");
      TableHead.push("Task Id");
      TableHead.push("Task Name");
      TableHead.push("Start Time");
      TableHead.push("End Time");
      TableHead.push("Status");
      TableHead.push("Working Hours");

      const replacer = (key, value) => (value === null ? "N/A" : value);
      const header = Object.keys(items[0]);
      let csv = items.map((row) =>
        header
          .map((fieldName) => JSON.stringify(row[fieldName], replacer))
          .join(",")
      );
      csv.unshift(TableHead.join(","));
      csv.unshift(Space.join(","));
      csv.unshift(ProjectWorkingHour.join(","));
      csv.unshift(User.join(","));
      csv.unshift(Project.join(","));
      csv.unshift(Date.join(","));
      csv.unshift(DetailedReport.join(","));
      csv = csv.join("\r\n");
      const ConvertData = csv;
      const element = document.createElement("a");
      const file = new Blob([ConvertData], {
        type: "text/plain",
      });
      element.href = URL.createObjectURL(file);
      element.download = "DetailedProjectReport.csv";
      document.body.appendChild(element);
      element.click();
    }
  };

  const fetchDetailedTaskDetails = async (taskId, expandId) => {
    if (expandId !== 0) {
      try {
        setExpandIsLoading(true);
        let searchStartDate = startDate.split("/").reverse().join("-");
        let searchEndDate = endDate.split("/").reverse().join("-");
        const selUsrId =
          selectedAssignee === "All" ? defaultAllSelection : selectedAssigneeId;
        const response = await fetch(
          `${domain}task-detailed-report/?task_id=${taskId}&user_id=${selUsrId}&start_date=${searchStartDate}&end_date=${searchEndDate}&company_id=${requestCompanyId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          setExpandTaskDetails(res);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error('REQUEST_FAILED');
        }
      } catch (error) {
        console.error('[Projecttaskreport] operation failed:', error);
        showToast("error", "Couldn't load task report data. Please try again.");
      } finally {
        setExpandIsLoading(false);
      }
    }
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  };
  useEffect(() => {
    const filteredResults = allProRepDetails.filter((item) =>
      keys.some((key) =>
        getNestedValue(item, key)
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setAllUser(filteredResults);
    setPage(0);
  }, [allProRepDetails, globalSearchValue]);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  const updateUserName = (event, data) => {
    if (data) {
      setSelectedAssignee(data?.label);
      setSelectedAssigneeId(data?.user_id);
      setSelectedUser(data);
      setShowAutoCompleteAvathar(false);
    } else {
      setShowAutoCompleteAvathar(true);
    }
  };

  return (
    <React.Fragment>
      <Mui.Grid container spacing={1} sx={{ mt: 0 }}>
        <Mui.Grid item xs={12} sm={12} md={12} lg={12}>
          <Mui.Stack direction="row">
            <BackArrow actionFunction={() => updateShowReport(false)} />
            <Mui.Typography
              sx={{
                fontSize: 20,
                fontWeight: "bold",
                mt: 1.5,
              }}
            >
              Project Task Report
            </Mui.Typography>
          </Mui.Stack>
        </Mui.Grid>
      </Mui.Grid>
      <Mui.Grid container spacing={1} sx={{ mt: 1, mb: 1 }}>
        <Mui.Grid item xs={12} sm={6} md={3} lg={2}>
          <Mui.Autocomplete
            disablePortal
            id="combo-box-demo"
            size="small"
            sx={{ minWidth: "100%" }}
            value={
              allProjectDetails?.find(
                (option) => option?.label === selectedProject
              ) ||
              selectedProject ||
              ""
            }
            options={allProjectDetails}
            ListboxProps={{
              style: {
                maxHeight: "150px",
              },
            }}
            filterOptions={(options, state) => {
              return options?.filter((option) =>
                option?.label
                  ?.toLowerCase()
                  .includes(state.inputValue.toLowerCase())
              );
            }}
            renderOption={(props, option) => {
              return <li {...props}>{option?.label}</li>;
            }}
            onChange={(event, value) => {
              if (value && value?.label) {
                setSelectedProject(value.label);
                setSelectedAssignee("All");
                setSelectedProjectId(value.project_id);
              }
            }}
            renderInput={(params) => (
              <Mui.TextField
                {...params}
                size="small"
                label="Project"
                sx={{ background: "white" }}
                name="projects"
                placeholder="Select Project"
              />
            )}
          />
        </Mui.Grid>
        <Mui.Grid item xs={12} sm={6} md={3} lg={2}>
          <CustomAutoCompleteWithLogo
            dataList={allUserDetails?.map((obj) => ({
              ...obj,
              label: obj.user_name,
              image: obj?.image_url,
            }))}
            selectedValue={selectedUser}
            updateDataFunction={updateUserName}
            placeHolder="Select user name"
            label="User Name"
            showAvathar={showAutoCompleteAvathar}
            setShowAutoCompleteAvathar={setShowAutoCompleteAvathar}
          />
        </Mui.Grid>
        <Mui.Grid item xs={12} sm={6} md={3.5} lg={2}>
          <BSDateRangePicker
            handleStartDate={handleStartDate}
            showToday={true}
            triggerDate={true}
          />
        </Mui.Grid>
        <Mui.Grid item lg={5}></Mui.Grid>
        <Mui.Grid item xs={2} sm={2} md={2} lg={1}>
          <Mui.IconButton
            onClick={(event) => {
              handleMenuOpen(event);
            }}
            disabled={allUser?.length === 0 ? true : false}
          >
            <DownloadForOffline
              size="large"
              sx={{ color: themes.downloadIconColor, fontSize: 40, mt: -1 }}
            />
          </Mui.IconButton>
          <Mui.Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            elevation={1}
            transformOrigin={{
              horizontal: "right",
              vertical: "top",
            }}
            anchorOrigin={{
              horizontal: "right",
              vertical: "bottom",
            }}
          >
            <>
              <Mui.Stack>
                <Mui.MenuItem
                  key={"SummarizedReport"}
                  onClick={() => getSummarizedUserReport()}
                >
                  Summarized Report
                </Mui.MenuItem>
                <Mui.MenuItem
                  key={"DetailedReport"}
                  onClick={() => getDetailedProjectReport()}
                >
                  Detailed Report
                </Mui.MenuItem>
              </Mui.Stack>
            </>
          </Mui.Menu>
        </Mui.Grid>
      </Mui.Grid>

      {isLoading ? (
        <Loader info="Loading..." />
      ) : (
        <>
          <Mui.Grid container sx={{ overflow: "hidden", mt: 2 }}>
            <Mui.TableContainer sx={tableContainerSx}>
              <Mui.Table className="border">
                <Mui.TableHead
                  sx={{
                    backgroundColor: themes.primary,
                    position: "sticky",
                    top: -1,
                    zIndex: 100,
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Mui.TableRow
                    maxWidth="xl"
                    align="left"
                    sx={{
                      "& .MuiTableCell-root": {
                        height: "15px",
                        padding: "3px 15px",
                      },
                    }}
                  >
                    <Mui.TableCell></Mui.TableCell>
                    <Mui.TableCell
                      sx={{ color: themes.blackColor, fontWeight: "bold" }}
                    >
                      Project Name
                    </Mui.TableCell>
                    <Mui.TableCell
                      sx={{ color: themes.blackColor, fontWeight: "bold" }}
                    >
                      Task Id
                    </Mui.TableCell>
                    <Mui.TableCell
                      sx={{ color: themes.blackColor, fontWeight: "bold" }}
                    >
                      Task Name
                    </Mui.TableCell>
                    <Mui.TableCell
                      sx={{ color: themes.blackColor, fontWeight: "bold" }}
                    >
                      Task Owner
                    </Mui.TableCell>
                    <Mui.TableCell
                      sx={{ color: themes.blackColor, fontWeight: "bold" }}
                    >
                      Date
                    </Mui.TableCell>

                    <Mui.TableCell
                      sx={{ color: themes.blackColor, fontWeight: "bold" }}
                    >
                      Hours
                    </Mui.TableCell>
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {allUser?.length === 0 ? (
                    <TableEmptyState dataLength={allProRepDetails} />
                  ) : (
                    allUser
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((item, index) => (
                        <>
                          <Mui.TableRow
                            key={item?.id}
                            sx={{
                              "& .MuiTableCell-root": {
                                height: "10px",
                                padding: "3px 15px",
                              },
                            }}
                          >
                            <Mui.TableCell align="left">
                              <Mui.IconButton
                                size="small"
                                sx={{ marginRight: 2 }}
                                onClick={() => {
                                  setExpandUserDet(
                                    item?.id === expandUserDet ? 0 : item?.id
                                  );
                                  fetchDetailedTaskDetails(
                                    item?.id,
                                    item?.id === expandUserDet ? 0 : item?.id
                                  );
                                }}
                              >
                                {expandUserDet === item?.id ? (
                                  <KeyboardArrowDown
                                    size="small"
                                    sx={{ stroke: 2, color: themes.blackColor }}
                                  />
                                ) : (
                                  <NavigateNext
                                    size="small"
                                    sx={{ stroke: 2, color: themes.blackColor }}
                                  />
                                )}
                              </Mui.IconButton>
                            </Mui.TableCell>
                            <Mui.TableCell>
                              {item?.project?.projectname
                                ? item?.project?.projectname
                                : "N/A"}
                            </Mui.TableCell>
                            <Mui.TableCell>
                              {item?.task_code ? item?.task_code : "N/A"}
                            </Mui.TableCell>
                            <Mui.TableCell>{item?.taskname}</Mui.TableCell>
                            <Mui.TableCell>
                              <Mui.Stack direction="Row">
                                <Mui.Avatar
                                  sx={{ width: 23, height: 23 }}
                                  alt={item?.task_owner?.username
                                    ?.charAt(0)
                                    .toUpperCase()}
                                  src={
                                    item?.task_owner?.image_url ??
                                    optionalAvathar
                                  }
                                />
                                &nbsp;
                                {item?.task_owner?.username
                                  ? item?.task_owner?.username
                                  : "N/A"}
                              </Mui.Stack>
                            </Mui.TableCell>

                            <Mui.TableCell>
                              {item?.time_entries
                                ? item?.time_entries[0]?.date
                                : "N/A"}
                            </Mui.TableCell>

                            <Mui.TableCell>
                              {item?.total_time ? item?.total_time : "00:00"}
                            </Mui.TableCell>
                          </Mui.TableRow>

                          {expandUserDet === item?.id && (
                            <Mui.TableRow sx={tableRowSx}>
                              <Mui.TableCell colSpan={7}>
                                <Mui.TableContainer
                                  sx={{
                                    paddingRight: 5,
                                    paddingLeft: 5,
                                  }}
                                >
                                  {expandIsLoading ? (
                                    <Loader info="Loading..." />
                                  ) : (
                                    <>
                                      {expandTaskDetails?.length !== 0 ? (
                                        <Mui.Table className="border">
                                          <Mui.TableHead
                                            sx={{
                                              backgroundColor: themes.primary,
                                            }}
                                          >
                                            <Mui.TableRow sx={tableRowSx}>
                                              <Mui.TableCell
                                                sx={{
                                                  color: themes.blackColor,
                                                  fontWeight: "bold",
                                                  overflow: "hidden",
                                                  whiteSpace: "nowrap",
                                                  maxWidth: 100,
                                                  width: "20%",
                                                }}
                                              >
                                                User Name
                                              </Mui.TableCell>
                                              <Mui.TableCell
                                                sx={{
                                                  color: themes.blackColor,
                                                  fontWeight: "bold",
                                                  overflow: "hidden",
                                                  width: "20%",
                                                  whiteSpace: "nowrap",
                                                  maxWidth: 100,
                                                }}
                                              >
                                                Status
                                              </Mui.TableCell>
                                              <Mui.TableCell
                                                sx={{
                                                  color: themes.blackColor,
                                                  fontWeight: "bold",
                                                  overflow: "hidden",
                                                  whiteSpace: "nowrap",
                                                  maxWidth: 100,
                                                  width: "20%",
                                                }}
                                              >
                                                Start Time
                                              </Mui.TableCell>
                                              <Mui.TableCell
                                                sx={{
                                                  color: themes.blackColor,
                                                  fontWeight: "bold",
                                                  overflow: "hidden",
                                                  whiteSpace: "nowrap",
                                                  maxWidth: 100,
                                                  width: "20%",
                                                }}
                                              >
                                                End Time
                                              </Mui.TableCell>
                                              <Mui.TableCell
                                                sx={{
                                                  color: themes.blackColor,
                                                  fontWeight: "bold",
                                                  overflow: "hidden",
                                                  whiteSpace: "nowrap",
                                                  maxWidth: 100,
                                                  width: "20%",
                                                }}
                                              >
                                                Hours
                                              </Mui.TableCell>
                                            </Mui.TableRow>
                                          </Mui.TableHead>
                                          <Mui.TableBody>
                                            {expandTaskDetails?.map(
                                              (rowentry, index) => (
                                                <Mui.TableRow
                                                  key={index}
                                                  sx={tableRowSx}
                                                >
                                                  <Mui.TableCell
                                                    sx={{
                                                      overflow: "hidden",
                                                      whiteSpace: "nowrap",
                                                      maxWidth: 100,
                                                    }}
                                                  >
                                                    <Mui.Typography
                                                      sx={{
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        textOverflow:
                                                          "ellipsis",
                                                      }}
                                                    >
                                                      <Mui.Stack direction="Row">
                                                        <Mui.Avatar
                                                          sx={{
                                                            width: 23,
                                                            height: 23,
                                                          }}
                                                          alt={rowentry?.user_name
                                                            ?.charAt(0)
                                                            .toUpperCase()}
                                                          src={
                                                            rowentry?.image_url ??
                                                            optionalAvathar
                                                          }
                                                        />
                                                        &nbsp;
                                                        {rowentry?.detail
                                                          ?.assignee
                                                          ? rowentry?.detail
                                                              ?.assignee
                                                          : rowentry?.user_name}
                                                      </Mui.Stack>
                                                    </Mui.Typography>
                                                  </Mui.TableCell>
                                                  <Mui.TableCell
                                                    sx={{
                                                      overflow: "hidden",
                                                      whiteSpace: "nowrap",
                                                      maxWidth: 100,
                                                    }}
                                                  >
                                                    <Mui.Typography
                                                      sx={{
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        textOverflow:
                                                          "ellipsis",
                                                      }}
                                                    >
                                                      {rowentry?.task_status
                                                        ? rowentry?.task_status
                                                        : "N/A"}
                                                    </Mui.Typography>
                                                  </Mui.TableCell>
                                                  <Mui.TableCell
                                                    sx={{
                                                      overflow: "hidden",
                                                      whiteSpace: "nowrap",
                                                      textOverflow: "ellipsis",
                                                    }}
                                                  >
                                                    <Mui.Typography
                                                      sx={{
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        textOverflow:
                                                          "ellipsis",
                                                      }}
                                                    >
                                                      {rowentry?.start_time
                                                        ? rowentry?.start_time
                                                        : "N/A"}
                                                    </Mui.Typography>
                                                  </Mui.TableCell>
                                                  <Mui.TableCell
                                                    sx={{
                                                      overflow: "hidden",
                                                      whiteSpace: "nowrap",
                                                      textOverflow: "ellipsis",
                                                    }}
                                                  >
                                                    <Mui.Typography
                                                      sx={{
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        textOverflow:
                                                          "ellipsis",
                                                      }}
                                                    >
                                                      {rowentry?.end_time
                                                        ? rowentry?.end_time
                                                        : "N/A"}
                                                    </Mui.Typography>
                                                  </Mui.TableCell>
                                                  <Mui.TableCell
                                                    sx={{
                                                      overflow: "hidden",
                                                      whiteSpace: "nowrap",
                                                      textOverflow: "ellipsis",
                                                    }}
                                                  >
                                                    <Mui.Typography
                                                      sx={{
                                                        overflow: "hidden",
                                                        whiteSpace: "nowrap",
                                                        textOverflow:
                                                          "ellipsis",
                                                      }}
                                                    >
                                                      {rowentry?.hours
                                                        ? rowentry?.hours
                                                        : "00:00"}
                                                    </Mui.Typography>
                                                  </Mui.TableCell>
                                                </Mui.TableRow>
                                              )
                                            )}
                                          </Mui.TableBody>
                                        </Mui.Table>
                                      ) : (
                                        <Mui.Stack
                                          sx={{ padding: 0.5 }}
                                          spacing={2}
                                          fullWidth
                                        >
                                          <Mui.Alert severity="info">
                                            There is a no available task
                                          </Mui.Alert>
                                        </Mui.Stack>
                                      )}
                                    </>
                                  )}
                                </Mui.TableContainer>
                              </Mui.TableCell>
                            </Mui.TableRow>
                          )}
                        </>
                      ))
                  )}
                </Mui.TableBody>
                {allUser?.length !== 0 ? (
                  <Mui.TableBody>
                    <Mui.TableRow sx={tableRowSx}>
                      <Mui.TableCell></Mui.TableCell>
                      <Mui.TableCell></Mui.TableCell>
                      <Mui.TableCell></Mui.TableCell>
                      <Mui.TableCell></Mui.TableCell>
                      <Mui.TableCell></Mui.TableCell>
                      <Mui.TableCell
                        sx={{
                          color: themes.blackColor,
                          fontWeight: "bold",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <Mui.Typography
                          sx={{ fontSize: 15, fontWeight: "bold" }}
                        >
                          Total Working Hours
                        </Mui.Typography>
                      </Mui.TableCell>
                      <Mui.TableCell>
                        <Mui.Typography
                          sx={{
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {totWorkingHours ? totWorkingHours : "00:00"}
                        </Mui.Typography>
                      </Mui.TableCell>
                    </Mui.TableRow>
                  </Mui.TableBody>
                ) : null}
              </Mui.Table>
            </Mui.TableContainer>
          </Mui.Grid>

          {allUser?.length > 10 && (
            <Mui.TablePagination
              className="custom-pagination"
              component="div"
              rowsPerPageOptions={[25, 50, 75, 100]}
              count={allUser?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default ProjectTaskReport;
